module.exports = __webpack_public_path__ + "static/media/arrow_up.2a92c28b.svg";